import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20collage%20with%20film%20strip%20and%20theater%20elements%2C%20warm%20golden%20and%20amber%20lighting%2C%20artistic%20abstract%20composition%2C%20dark%20background%20with%20red%20accents%2C%20professional%20cinematography%20style&width=600&height=400&seq=cat-movie&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Television%20drama%20series%20artistic%20collage%20with%20vintage%20TV%20set%20and%20modern%20screens%2C%20warm%20cozy%20living%20room%20ambience%2C%20golden%20hour%20lighting%2C%20dark%20background%2C%20cinematic%20composition&width=600&height=400&seq=cat-tv&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20art%20style%20colorful%20fantasy%20landscape%20with%20vibrant%20characters%20silhouette%2C%20Japanese%20animation%20aesthetic%20with%20cherry%20blossoms%2C%20dreamy%20atmosphere%2C%20dark%20background%20with%20pink%20and%20teal%20accents&width=600&height=400&seq=cat-anime&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Entertainment%20show%20stage%20with%20colorful%20lights%20and%20confetti%2C%20energetic%20variety%20show%20atmosphere%2C%20bright%20spotlights%20on%20dark%20stage%2C%20professional%20studio%20photography%2C%20vibrant%20warm%20colors&width=600&height=400&seq=cat-variety&orientation=landscape',
];

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50" aria-label="影视分类导航">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            探索精彩内容
          </h2>
          <p className="text-sm text-foreground-600 mt-3">选择你喜欢的分类，发现更多好片</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-48 md:h-56 cursor-pointer"
            >
              <img
                src={categoryImages[index]}
                alt={`屁屁影院${cat.name}分类`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1">
                  <i className={`${cat.icon} text-white text-lg`}></i>
                  <h3 className="text-lg md:text-xl font-bold text-white">{cat.name}</h3>
                </div>
                <p className="text-white/70 text-xs md:text-sm">
                  {cat.slug === 'movie' && '热门大片 精彩不断'}
                  {cat.slug === 'tv' && '热播剧集 每日更新'}
                  {cat.slug === 'anime' && '国漫日漫 应有尽有'}
                  {cat.slug === 'variety' && '爆笑综艺 欢乐不停'}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}